/* istanbul ignore file */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-address-validation-modal-window',
  templateUrl: './address-validation-modal-window.component.html'
})
export class AddressValidationModalWindowComponent {

  constructor(
    public dialogRef: MatDialogRef<AddressValidationModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) {
  }

  onClose(value: string) {
    this.dialogRef.close(value);
  }
}
